<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TruckDetail"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Detail Master Batangan
                  </h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px"
                  >
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.create_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.update_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="card">
                      <div class="row mx-4 my-4">
                        <div class="col-sm-6">
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("vehicle_no") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="vehicle_no"
                                :placeholder="$t('vehicle_no')"
                                v-model="forms.vehicle_no"
                                required
                              />
                              <div v-if="errors.vehicle_no">
                                <div
                                  v-for="error in errors.vehicle_no"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("truck_type") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="truck_type"
                                :placeholder="$t('truck_type')"
                                v-model="forms.truck_type"
                                required
                              />
                              <div v-if="errors.truck_type">
                                <div
                                  v-for="error in errors.truck_type"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("truck_brand") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="merk"
                                :placeholder="$t('truck_brand')"
                                v-model="forms.merk"
                                required
                              />
                              <div v-if="errors.merk">
                                <div
                                  v-for="error in errors.merk"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("branch_id") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="branch"
                                :placeholder="$t('branch_id')"
                                v-model="forms.branch"
                                required
                              />
                              <div v-if="errors.branch">
                                <div
                                  v-for="error in errors.branch"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("driver_id") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="driver_id"
                                :placeholder="$t('driver_id')"
                                v-model="forms.driver_id"
                                required
                              />
                              <div v-if="errors.driver_id">
                                <div
                                  v-for="error in errors.driver_id"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("driver_name") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="driver_name"
                                :placeholder="$t('driver_name')"
                                v-model="forms.driver_name"
                                required
                              />
                              <div v-if="errors.driver_name">
                                <div
                                  v-for="error in errors.driver_name"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("sim") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="sim"
                                :placeholder="$t('sim')"
                                v-model="forms.sim"
                                required
                              />
                              <div v-if="errors.sim">
                                <div
                                  v-for="error in errors.sim"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("startDate") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="date"
                                disabled
                                class="form-control"
                                id="start_date"
                                :placeholder="$t('startDate')"
                                v-model="forms.start_date"
                                required
                              />
                              <div v-if="errors.start_date">
                                <div
                                  v-for="error in errors.start_date"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-sm-12">
                        <div class="row">
                          <h6>Vehicle History</h6>
                        </div>
                        <div class="row">
                          <vue-good-table
                            title="list-user"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :rows="rows"
                            :columns="columns"
                          >
                          </vue-good-table>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_update"
                        class="btn btn-primary me-2 text-white fw-bolder btn-icon-text float-end"
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                    </div>
                  </form>

                  <!--end::loading-data-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "DriverDetail",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role: [],
      isLoading: false,
      branch: "",
      fetchDriver: [],
      driver: "",
      type_truck: "",
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      forms: [],
      columns: [
        {
          label: "Vehicle No",
          field: "vehicle_no",
        },
        {
          label: "Truck Type",
          field: "truck_type",
        },
        {
          label: "Driver Id",
          field: "driver_id",
        },
        {
          label: "Driver Name",
          field: "driver_name",
        },
        {
          label: "Driver Status",
          field: "driver_status",
        },
        {
          label: "Start Date",
          field: "start_date",
        },
        {
          label: "Create At",
          field: "created_at",
        },
        {
          label: "Update At",
          field: "updated_at",
        },
        {
          label: "Create By",
          field: "created_by",
        },
        {
          label: "Update By",
          field: "updated_by",
        },
      ],
      rows: [],
    };
  },
  watch: {},
  methods: {
    resetForm() {},

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/master-batangan/edit/" + params;
    },

    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointCt + "master-truck/delete/" + id;
          this.$http
            .delete(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/truck";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  //this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    backForm() {
      window.location.href = "/master-batangan";
    },

    loadData(id) {
      const baseURI =
        this.$settings.endPointCt + "master-batangan/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        console.log(response);
        this.forms = response.data.datas;
        this.rows = this.forms.log;
        // this.branch = response.data.datas.branch
        // this.type_truck = response.data.datas.type_truck
        // this.forms.driver_name=response.data.datas.driver!=null ? response.data.datas.driver.driver_name : ""
        // this.form={ name: 'asep', usernmae:res.username };
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterBatanganController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    // var params = this.$onBehind(this.$route.params.id);
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    this.loadData(this.$route.params.id);
    this.fetchIt();
  },
};
</script>
<style scoped></style>
